import * as React from 'react';

interface IDefaultProps {

}


export const DefaultPage: React.FunctionComponent<IDefaultProps> = (props) => {

    return (<div>Bla bla !!!!</div>)
}
